import {
    Button,
    Card,
    Grid,
    Typography,
    CardContent
  } from '@mui/material';
  import { Helmet } from 'react-helmet';
  import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
  import FormControl from '@mui/material/FormControl';
  import OutlinedInput from '@mui/material/OutlinedInput';
  import {Download} from 'react-feather';
  import { _axios } from 'src/plugins/axios';
  import commonService from 'src/service/common';
  import React, { useState } from 'react';
  
  const menuList = [{
    id: 'employeeId',
    title: 'EmployeeId',
  }]
  function Repository(props) {
      const [searchEmpId, setSearchEmpId] = useState('');
      const [reports, setReports] = useState([])
      const [isFound, setIsFound] = useState('')
  
      function handleSearch(e){
        _axios.post('ahc/fileDownload', 
            {
                employeeId : searchEmpId,
                contractId: props.contractId
            }, {
          ignoreLoading: false,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }).then(response =>{
          if(response.data.isSuccess){
            if(response.data.result.length > 0){
              setReports(response.data.result)
              setIsFound('')
            } else {
              setReports([])
            }
          }
        }).catch(error =>{
          setReports([])
          setIsFound('Error while fetching Reports')
        })
      }
    
    return (
      <>
        <Helmet>
          <title>Repository</title>
        </Helmet>
        <Grid
          container
          sx={{
            width: '100%',
            borderRadius: 4,
            p: 3,
            pt: 2
          }}
        >
          <Grid item xs={12}>
            <Card
              sx={{
                width: '100%',
                borderRadius: 4,
                mb: 2,
                p: 3,
                boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
              }}
            >
              <Grid container>
                <Grid item sx={12} container>
                  <Grid item sm={3}>
                  <FormControl size='small' variant="filled" fullWidth>
                        <OutlinedInput
                          id="outlined-search"
                          sx={{
                            boxShadow: 0,
                            bgcolor: '#f2f2f2'
                          }}
                          labelWidth={0}
                          value={searchEmpId}
                          onChange={(e)=>setSearchEmpId(e.target.value)}
                          placeholder={`Search by EmployeeId`}
                        />
                      </FormControl>
                  </Grid>
                  <Grid item>
                    <Button sx={{ ml:2, px: 3, boxShadow: '0 0 4px rgba(0,0,0,0.20)' }} color="primary"
                          startIcon={<SearchIcon size="18"/>} onClick={handleSearch}
                    > Search</Button>
                  </Grid>
                      
                      
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
        {reports.map((report, i) =>{
        return (<Grid key={i} container>
            <Grid item sx={{width: '96%', ml: 3, mb: 2}}>
            <Card sx={{borderRadius: 4}}>
                <CardContent>
                  <Grid container>
                    <Grid item sm={5}>
                      <Typography>
                          {report.ProductName}
                      </Typography>
                    </Grid>
                    <Grid item sm={5}>
                      <Typography>
                        <a target="_blank" href={report.downloadlink}>
                          <Grid container>
                            <Grid item>
                              <Download />
                            </Grid>
                            <Grid item sx={{ml:2}}>
                              <Typography>Click here to Download the Report</Typography>
                            </Grid>
                          </Grid>
                          </a>
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
            </Card>
          </Grid>
        </Grid>)
          })}
          {isFound !== '' && <Typography xs={3} sx={{ml:'42%', color: 'red'}}>No reports found</Typography>}
      </>
    );
  }
  
  export default Repository;
  